var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{ref:"wallContainer",class:[
    {
      relative: true,
      'scrollbar-photo': _setup.backgroundLuminance === 'light',
      'scrollbar-photo-dark': _setup.backgroundLuminance === 'dark',
    },
    !_setup.isReadOnly && 'overflow-auto',
  ],style:({
    direction: 'ltr',
  }),attrs:{"id":"wall-container","aria-label":_setup.__('Canvas')},on:{"scroll":_setup.handlePageScroll}},[_c(_setup.ScreenReaderSpeechNotifications,{attrs:{"message":_setup.screenReaderMessage}}),_vm._v(" "),(_setup.xHeader)?_c(_setup.SurfaceHeader,{staticClass:"fixed end-0",style:({
      top: `${_setup.headerTop}px`,
      left: `${_setup.headerLeft}px`,
    })}):_vm._e(),_vm._v(" "),_c(_setup.SurfacePosts,{attrs:{"reaction-ids-by-post-id":_vm.reactionIdsByPostId,"comment-ids-by-post-id":_vm.commentIdsByPostId},on:{"focus-post":_setup.updateScreenReaderMessageOnPostFocus}}),_vm._v(" "),_c('div',{staticClass:"gutter-sizer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }